// 管理者ログイン画面
import AdminLogin from '@/components/Admin/Login/AdminLogin'
// 管理者予約状況確認画面
import AdminReserveStatusCheck from '@/components/Admin/ReserveStatusCheck/AdminReserveStatusCheck'

// マスタ関連
// 休業日マスタ
import MasterWCALM from '@/components/Admin/Master/WCALM/MasterWCALM'
import MasterWCALMBulk from '@/components/Admin/Master/WCALM/MasterWCALMBulk'

// CSVパターン
import CSVPatternList from '@/components/Admin/Master/WCSV/CSVPatternList'
import CSVPatternDetail from '@/components/Admin/Master/WCSV/CSVPatternDetail'

// 受診者抽出
import WIGA1 from '@/components/Admin/Master/WIGA1/WIGA1'
import WIGA1Detail from '@/components/Admin/Master/WIGA1/WIGA1Detail'
import WIGA1Detail2 from '@/components/Admin/Master/WIGA1/WIGA1Detail2'
import WIGA1DetailCalender from '@/components/Admin/Master/WIGA1/WIGA1DetailCalender'

// 医療機関マスタ
import MasterWIRKNUpdate from '@/components/Admin/Master/WIRKN/MasterWIRKNUpdate'
import MasterWIRKNUpdateDone from '@/components/Admin/Master/WIRKN/MasterWIRKNUpdateDone'

// コースマスタ
import MasterWIRKSList from '@/components/Admin/Master/WIRKS/MasterWIRKSList'
import MasterWIRKSDetail from '@/components/Admin/Master/WIRKS/MasterWIRKSDetail'
import MasterWIRKSDetailUpdate from '@/components/Admin/Master/WIRKS/MasterWIRKSDetailUpdate'
import MasterWIRKSRegister from '@/components/Admin/Master/WIRKS/MasterWIRKSRegister'
import MasterWIRKSRegisterDone from '@/components/Admin/Master/WIRKS/MasterWIRKSRegisterDone'

// コース毎　検査項目マスタ
import MasterWIRKM from '@/components/Admin/Master/WIRKS/MasterWIRKM'
// コース毎　予約枠マスタ
import MasterWKSWK from '@/components/Admin/Master/WIRKS/MasterWKSWK'
// コース毎　料金条件マスタ
import MasterWRKKS from '@/components/Admin/Master/WIRKS/MasterWRKKS'
// コース毎　オプション条件マスタ
import MasterWRKOP from '@/components/Admin/Master/WIRKS/MasterWRKOP'
// コース年度更新
import MasterWIRKSBulk from '@/components/Admin/Master/WIRKS/MasterWIRKSBulk'

// クライアントマスタ
import MasterWJGYODetail from '@/components/Admin/Master/WJGYO/MasterWJGYODetail'
import MasterWJGYODetailUpdate from '@/components/Admin/Master/WJGYO/MasterWJGYODetailUpdate'
import MasterWJGYOList from '@/components/Admin/Master/WJGYO/MasterWJGYOList'
import MasterWJGYORegister from '@/components/Admin/Master/WJGYO/MasterWJGYORegister'
import MasterWJGYORegisterDone from '@/components/Admin/Master/WJGYO/MasterWJGYORegisterDone'
// 対象者区分マスタ(クライアントマスタからのみ遷移する)
import MasterWHFKBDetail from '@/components/Admin/Master/WJGYO/MasterWHFKBDetail'
import MasterWHFKBDetailUpdate from '@/components/Admin/Master/WJGYO/MasterWHFKBDetailUpdate'
import MasterWHFKBList from '@/components/Admin/Master/WJGYO/MasterWHFKBList'
import MasterWHFKBRegister from '@/components/Admin/Master/WJGYO/MasterWHFKBRegister'
import MasterWHFKBRegisterDone from '@/components/Admin/Master/WJGYO/MasterWHFKBRegisterDone'

// 検査項目マスタ
import MasterWKKMMDetail from '@/components/Admin/Master/WKKMM/MasterWKKMMDetail'
import MasterWKKMMDetailUpdate from '@/components/Admin/Master/WKKMM/MasterWKKMMDetailUpdate'
import MasterWKKMMList from '@/components/Admin/Master/WKKMM/MasterWKKMMList'
import MasterWKKMMRegister from '@/components/Admin/Master/WKKMM/MasterWKKMMRegister'
import MasterWKKMMRegisterDone from '@/components/Admin/Master/WKKMM/MasterWKKMMRegisterDone'

// メールテンプレートマスタ
import MasterWMAILDetail from '@/components/Admin/Master/WMAIL/MasterWMAILDetail'
import MasterWMAILDetailUpdate from '@/components/Admin/Master/WMAIL/MasterWMAILDetailUpdate'
import MasterWMAILList from '@/components/Admin/Master/WMAIL/MasterWMAILList'
import MasterWMAILRegister from '@/components/Admin/Master/WMAIL/MasterWMAILRegister'
import MasterWMAILRegisterDone from '@/components/Admin/Master/WMAIL/MasterWMAILRegisterDone'

// オプション分類マスタ
import MasterWOPBRDetail from '@/components/Admin/Master/WOPBR/MasterWOPBRDetail'
import MasterWOPBRDetailUpdate from '@/components/Admin/Master/WOPBR/MasterWOPBRDetailUpdate'
import MasterWOPBRList from '@/components/Admin/Master/WOPBR/MasterWOPBRList'
import MasterWOPBRRegister from '@/components/Admin/Master/WOPBR/MasterWOPBRRegister'
import MasterWOPBRRegisterDone from '@/components/Admin/Master/WOPBR/MasterWOPBRRegisterDone'

// オプション項目マスタ
import MasterWOPKMDetail from '@/components/Admin/Master/WOPKM/MasterWOPKMDetail'
import MasterWOPKMDetailUpdate from '@/components/Admin/Master/WOPKM/MasterWOPKMDetailUpdate'
import MasterWOPKMList from '@/components/Admin/Master/WOPKM/MasterWOPKMList'
import MasterWOPKMRegister from '@/components/Admin/Master/WOPKM/MasterWOPKMRegister'
import MasterWOPKMRegisterDone from '@/components/Admin/Master/WOPKM/MasterWOPKMRegisterDone'

// 時間帯マスタ
import MasterWTMZNDetail from '@/components/Admin/Master/WTMZN/MasterWTMZNDetail'
import MasterWTMZNDetailUpdate from '@/components/Admin/Master/WTMZN/MasterWTMZNDetailUpdate'
import MasterWTMZNList from '@/components/Admin/Master/WTMZN/MasterWTMZNList'
import MasterWTMZNRegister from '@/components/Admin/Master/WTMZN/MasterWTMZNRegister'
import MasterWTMZNRegisterDone from '@/components/Admin/Master/WTMZN/MasterWTMZNRegisterDone'

// ユーザーマスタ(未作成)

// 予約枠マスタ
import MasterWWAKUDetail from '@/components/Admin/Master/WWAKU/MasterWWAKUDetail'
import MasterWWAKUDetailUpdate from '@/components/Admin/Master/WWAKU/MasterWWAKUDetailUpdate'
import MasterWWAKUList from '@/components/Admin/Master/WWAKU/MasterWWAKUList'
import MasterWWAKURegister from '@/components/Admin/Master/WWAKU/MasterWWAKURegister'
import MasterWWAKURegisterDone from '@/components/Admin/Master/WWAKU/MasterWWAKURegisterDone'

// 予約登録枠数管理マスタ
import MasterWWKKR from '@/components/Admin/Master/WWKKR/MasterWWKKR'
import MasterWWKKRBulk from '@/components/Admin/Master/WWKKR/MasterWWKKRBulk'

export default [
  //--------------------------------------------------
  // 管理者系
  // --------------------------------------------------
  // 管理者ログイン画面
  {
    path: '/AdminLogin',
    name: 'AdminLogin',
    component: AdminLogin
  },
  // 状況確認画面（ホーム）
  {
    path: '/AdminReserveStatusCheck',
    name: 'AdminReserveStatusCheck',
    component: AdminReserveStatusCheck
  },
  // マスタ管理

  // 休業日マスタ
  {
    path: '/MasterWCALM',
    name: 'MasterWCALM',
    component: MasterWCALM
  },
  {
    path: '/MasterWCALMBulk',
    name: 'MasterWCALMBulk',
    component: MasterWCALMBulk
  },
  // CSVパターン
  {
    path: '/CSVPatternList',
    name: 'CSVPatternList',
    component: CSVPatternList
  },
  {
    path: '/CSVPatternDetail',
    name: 'CSVPatternDetail',
    component: CSVPatternDetail
  },

  // 受診者抽出
  {
    path: '/WIGA1',
    name: 'WIGA1',
    component: WIGA1
  },

  // 予約状況編集
  {
    path: '/WIGA1Detail',
    name: 'WIGA1Detail',
    component: WIGA1Detail
  },

  // 予約状況編集 結果画面
  {
    path: '/WIGA1Detail2',
    name: 'WIGA1Detail2',
    component: WIGA1Detail2
  },

  // 予約状況編集 カレンダー選択画面
  {
    path: '/WIGA1DetailCalender',
    name: 'WIGA1DetailCalender',
    component: WIGA1DetailCalender
  },

  // 医療機関基本情報マスタ
  {
    path: '/MasterWIRKNUpdate',
    name: 'MasterWIRKNUpdate',
    component: MasterWIRKNUpdate
  },
  {
    path: '/MasterWIRKNUpdateDone',
    name: 'MasterWIRKNUpdateDone',
    component: MasterWIRKNUpdateDone
  },

  // コースマスタ
  // コースマスタ一覧
  {
    path: '/MasterWIRKSList',
    name: 'MasterWIRKSList',
    component: MasterWIRKSList
  },
  // コースマスタ　新規作成
  {
    path: '/MasterWIRKSRegister',
    name: 'MasterWIRKSRegister',
    component: MasterWIRKSRegister
  },
  // コースマスタ　新規作成　結果
  {
    path: '/MasterWIRKSRegisterDone',
    name: 'MasterWIRKSRegisterDone',
    component: MasterWIRKSRegisterDone
  },
  // コースマスタ　詳細
  {
    path: '/MasterWIRKSDetail',
    name: 'MasterWIRKSDetail',
    component: MasterWIRKSDetail
  },
  // コースマスタ　詳細　結果
  {
    path: '/MasterWIRKSDetailUpdate',
    name: 'MasterWIRKSDetailUpdate',
    component: MasterWIRKSDetailUpdate
  },
  
  // コース毎　検査項目マスタ
  {
    path: '/MasterWIRKM',
    name: 'MasterWIRKM',
    component: MasterWIRKM
  },
  
  // コース毎　予約枠マスタ
  {
    path: '/MasterWKSWK',
    name: 'MasterWKSWK',
    component: MasterWKSWK
  },
  // コース毎　料金条件マスタ
  {
    path: '/MasterWRKKS',
    name: 'MasterWRKKS',
    component: MasterWRKKS
  },
  // コース毎　オプション条件マスタ
  {
    path: '/MasterWRKOP',
    name: 'MasterWRKOP',
    component: MasterWRKOP
  },
  // コース毎　オプション条件マスタ
  {
    path: '/MasterWIRKSBulk',
    name: 'MasterWIRKSBulk',
    component: MasterWIRKSBulk
  },

  // クライアントマスタ
  {
    path: '/MasterWJGYODetail',
    name: 'MasterWJGYODetail',
    component: MasterWJGYODetail
  },
  {
    path: '/MasterWJGYODetailUpdate',
    name: 'MasterWJGYODetailUpdate',
    component: MasterWJGYODetailUpdate
  },
  {
    path: '/MasterWJGYOList',
    name: 'MasterWJGYOList',
    component: MasterWJGYOList
  },
  {
    path: '/MasterWJGYORegister',
    name: 'MasterWJGYORegister',
    component: MasterWJGYORegister
  },
  {
    path: '/MasterWJGYORegisterDone',
    name: 'MasterWJGYORegisterDone',
    component: MasterWJGYORegisterDone
  },

  // 対象者区分マスタ
  {
    path: '/MasterWHFKBDetail',
    name: 'MasterWHFKBDetail',
    component: MasterWHFKBDetail
  },
  {
    path: '/MasterWHFKBDetailUpdate',
    name: 'MasterWHFKBDetailUpdate',
    component: MasterWHFKBDetailUpdate
  },
  {
    path: '/MasterWHFKBList',
    name: 'MasterWHFKBList',
    component: MasterWHFKBList
  },
  {
    path: '/MasterWHFKBRegister',
    name: 'MasterWHFKBRegister',
    component: MasterWHFKBRegister
  },
  {
    path: '/MasterWHFKBRegisterDone',
    name: 'MasterWHFKBRegisterDone',
    component: MasterWHFKBRegisterDone
  },

  // 検査項目マスタ
  {
    path: '/MasterWKKMMDetail',
    name: 'MasterWKKMMDetail',
    component: MasterWKKMMDetail
  },
  {
    path: '/MasterWKKMMDetailUpdate',
    name: 'MasterWKKMMDetailUpdate',
    component: MasterWKKMMDetailUpdate
  },
  {
    path: '/MasterWKKMMList',
    name: 'MasterWKKMMList',
    component: MasterWKKMMList
  },
  {
    path: '/MasterWKKMMRegister',
    name: 'MasterWKKMMRegister',
    component: MasterWKKMMRegister
  },
  {
    path: '/MasterWKKMMRegisterDone',
    name: 'MasterWKKMMRegisterDone',
    component: MasterWKKMMRegisterDone
  },

  // メールテンプレートマスタ
  {
    path: '/MasterWMAILDetail',
    name: 'MasterWMAILDetail',
    component: MasterWMAILDetail
  },
  {
    path: '/MasterWMAILDetailUpdate',
    name: 'MasterWMAILDetailUpdate',
    component: MasterWMAILDetailUpdate
  },
  {
    path: '/MasterWMAILList',
    name: 'MasterWMAILList',
    component: MasterWMAILList
  },
  {
    path: '/MasterWMAILRegister',
    name: 'MasterWMAILRegister',
    component: MasterWMAILRegister
  },
  {
    path: '/MasterWMAILRegisterDone',
    name: 'MasterWMAILRegisterDone',
    component: MasterWMAILRegisterDone
  },

  // オプション分類マスタ
  {
    path: '/MasterWOPBRDetail',
    name: 'MasterWOPBRDetail',
    component: MasterWOPBRDetail
  },
  {
    path: '/MasterWOPBRDetailUpdate',
    name: 'MasterWOPBRDetailUpdate',
    component: MasterWOPBRDetailUpdate
  },
  {
    path: '/MasterWOPBRList',
    name: 'MasterWOPBRList',
    component: MasterWOPBRList
  },
  {
    path: '/MasterWOPBRRegister',
    name: 'MasterWOPBRRegister',
    component: MasterWOPBRRegister
  },
  {
    path: '/MasterWOPBRRegisterDone',
    name: 'MasterWOPBRRegisterDone',
    component: MasterWOPBRRegisterDone
  },

  // オプション項目マスタ
  {
    path: '/MasterWOPKMDetail',
    name: 'MasterWOPKMDetail',
    component: MasterWOPKMDetail
  },
  {
    path: '/MasterWOPKMDetailUpdate',
    name: 'MasterWOPKMDetailUpdate',
    component: MasterWOPKMDetailUpdate
  },
  {
    path: '/MasterWOPKMList',
    name: 'MasterWOPKMList',
    component: MasterWOPKMList
  },
  {
    path: '/MasterWOPKMRegister',
    name: 'MasterWOPKMRegister',
    component: MasterWOPKMRegister
  },
  {
    path: '/MasterWOPKMRegisterDone',
    name: 'MasterWOPKMRegisterDone',
    component: MasterWOPKMRegisterDone
  },

  // 時間帯マスタ
  {
    path: '/MasterWTMZNDetail',
    name: 'MasterWTMZNDetail',
    component: MasterWTMZNDetail
  },
  {
    path: '/MasterWTMZNDetailUpdate',
    name: 'MasterWTMZNDetailUpdate',
    component: MasterWTMZNDetailUpdate
  },
  {
    path: '/MasterWTMZNList',
    name: 'MasterWTMZNList',
    component: MasterWTMZNList
  },
  {
    path: '/MasterWTMZNRegister',
    name: 'MasterWTMZNRegister',
    component: MasterWTMZNRegister
  },
  {
    path: '/MasterWTMZNRegisterDone',
    name: 'MasterWTMZNRegisterDone',
    component: MasterWTMZNRegisterDone
  },

  // ユーザー一覧

  // 予約枠マスタ
  {
    path: '/MasterWWAKUDetail',
    name: 'MasterWWAKUDetail',
    component: MasterWWAKUDetail
  },
  {
    path: '/MasterWWAKUDetailUpdate',
    name: 'MasterWWAKUDetailUpdate',
    component: MasterWWAKUDetailUpdate
  },
  {
    path: '/MasterWWAKUList',
    name: 'MasterWWAKUList',
    component: MasterWWAKUList
  },
  {
    path: '/MasterWWAKURegister',
    name: 'MasterWWAKURegister',
    component: MasterWWAKURegister
  },
  {
    path: '/MasterWWAKURegisterDone',
    name: 'MasterWWAKURegisterDone',
    component: MasterWWAKURegisterDone
  },

  // 予約登録枠数管理マスタ
  {
    path: '/MasterWWKKR',
    name: 'MasterWWKKR',
    component: MasterWWKKR
  },
  {
    path: '/MasterWWKKRBulk',
    name: 'MasterWWKKRBulk',
    component: MasterWWKKRBulk
  },
]



// WEBPACK FOOTER //
// ./src/router/adminRoutes.js